import { render, staticRenderFns } from "./handitemjiaban.vue?vue&type=template&id=5d3ff8e5"
import script from "./handitemjiaban.vue?vue&type=script&lang=js"
export * from "./handitemjiaban.vue?vue&type=script&lang=js"
import style0 from "./handitemjiaban.vue?vue&type=style&index=0&id=5d3ff8e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports